// Wording for the assistant-only plan marker. Same access as premium — the
// distinction is presentational only, so it lives in one place and is rendered
// three ways: inline on the patient card, as a pill in the conversation header,
// and as a strip above the chat.
export const ASSISTANT_ONLY_LABEL = 'Assistant';
export const ASSISTANT_ONLY_BANNER = 'ASSISTANT SEUL';
